export const isFilenameInAvailableExtensions = (fileName: string, extensions: string[]): boolean => {
    const fileExtension = fileName.split('.').pop();

    if (fileExtension) {
        return extensions.includes(`.${fileExtension}`);
    }

    return false;
};
